import { MenuSub } from '@/components/menu';
import { MegaMenuSubDropdown } from './components';
const MegaMenuSubReport = items => {
  const reportItem = items.find(
    item => item.title === 'Reports ' || item.title === 'Reports'
  );

  return <MenuSub className="menu-default py-2.5 lg:w-[225px]">
      {reportItem.children && MegaMenuSubDropdown(reportItem.children)}
    </MenuSub>;
};
export { MegaMenuSubReport };